const setSession = (item, data) =>
  sessionStorage.setItem(item, JSON.stringify(data));

export default setSession;
